import { collection, doc, setDoc, getDoc, getDocs, query, where, limit } from 'firebase/firestore';
import { db } from '../firebase';
import type { ProgressReport } from '../types/lesson';

export async function saveProgressReport(
  report: Omit<ProgressReport, 'id' | 'createdAt' | 'updatedAt'>
): Promise<ProgressReport> {
  const ref = doc(collection(db, 'progressReports'));
  const now = new Date().toISOString();
  const data: ProgressReport = {
    id: ref.id,
    ...report,
    createdAt: now,
    updatedAt: now,
  };
  await setDoc(ref, data);
  return data;
}

/**
 * Fetch a single progress report by its doc ID. Used by the read-only
 * ProgressReportViewerModal which gets the ID off the progress_report_delivered
 * chat message. Returns null when the doc doesn't exist.
 */
export async function getProgressReportById(id: string): Promise<ProgressReport | null> {
  const ref = doc(collection(db, 'progressReports'), id);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return snap.data() as ProgressReport;
}

export async function getProgressReportByOrderId(orderId: string): Promise<ProgressReport | null> {
  const q = query(
    collection(db, 'progressReports'),
    where('orderId', '==', orderId),
    limit(1)
  );
  const snap = await getDocs(q);
  if (snap.empty) return null;
  return snap.docs[0].data() as ProgressReport;
}
